<div >
  <p class="text-green-700">Multiple Selections</p>
  @for (o of currentQuestion.QuestionAnswers; track o) {
    <div>
      <div class="border-[2px] rounded-md border-solid w-full py-1 px-2 my-2 hover:cursor-pointer"
        [ngClass]="{'bg-green-300 text-standardwhite border-offblack':o.SelectedOption,'bg-grey-300 text-grey-900':currentQuestion.NASelected}" (click)="selectOption(o)">
        <p>{{o.Description}}</p>
      </div>
    </div>
  }
</div>
@if (currentQuestion.AllowNA) {
  <div class="mt-4  flex items-center" >
    <app-simple-toggle class="mr-2" [(isChecked)]="currentQuestion.NASelected" (isCheckedChange)="validateAnswered()"></app-simple-toggle>
    <label (click)="updateNA()" class="hover:cursor-pointer">Not Applicable</label>
  </div>
}